<template>
  <div class="app-container">
    <!-- 主要内容区域 -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
import Footer from '@/layout/Footer.vue'

export default {
  name: 'AppLayoutBottom',
  components: {
    Footer
  }
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;  /* 最小高度占满整个视口 */
  display: flex;
  flex-direction: column;  /* 垂直方向排列 */
}
.main-content {
  flex: 1;
  width: 100%;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>